module.exports = __webpack_public_path__ + "static/media/elliot.432d61fd.jpg";